import { useEffect } from 'react';
import { reportChatReceipt } from './chat.ts';

export interface ChatReadReceiptOptions {
  drawerOpen: boolean;
  conversationId: string | null;
  /** The newest message on screen, so each new one is read again. */
  lastMessageId: string | undefined;
}

/**
 * Read is the drawer open, in front of someone, with something in it — not
 * merely a conversation loaded. A drawer left open on a hidden tab is not
 * being read, so the tab coming back into view counts as a fresh look.
 */
export function useChatReadReceipt({
  drawerOpen,
  conversationId,
  lastMessageId,
}: ChatReadReceiptOptions): void {
  useEffect(() => {
    if (!drawerOpen || !conversationId || !lastMessageId) {
      return;
    }

    function reportIfVisible() {
      if (document.visibilityState === 'visible' && conversationId) {
        void reportChatReceipt(conversationId, 'read');
      }
    }

    reportIfVisible();
    document.addEventListener('visibilitychange', reportIfVisible);

    return () => document.removeEventListener('visibilitychange', reportIfVisible);
  }, [drawerOpen, conversationId, lastMessageId]);
}
